//Comentario necesario para codificación en UTF-8, ver Inc6743
(function () {
	var App = angular.module('pphhApp');
	App.directive('uploaderModel', ["$parse", function ($parse) {
		return {
			restrict: 'A',
			link: function (scope, iElement, iAttrs)
			{
				iElement.on("change", function(e)
				{
					$parse(iAttrs.uploaderModel).assign(scope, iElement[0].files[0]);
				});
			}
		};
	}]);
})();